import * as MUI from "@mui/material";
import { useEffect, useRef, useState } from "react";

const DEBOUNCE_MS = 150;

export default function DebouncedTextField({ value, onCommit, ...textFieldProps }) {
  const [input, setInput] = useState(value);
  const timeoutRef = useRef(null);

  useEffect(() => {
    clearTimeout(timeoutRef.current);
    setInput(value);
  }, [value]);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  function handleChange(event) {
    const nextValue = event.target.value;
    setInput(nextValue);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => onCommit(nextValue), DEBOUNCE_MS);
  }

  return <MUI.TextField {...textFieldProps} value={input} onChange={handleChange} />;
}
